export const getSeventhAnalysesData = state => state.seventhAnalyses.all;
export const getSeventhAnalysisData = state => state.seventhAnalyses.seventhAnalysis;
export const seventhAnalysesIsFetching = state => state.seventhAnalyses.loading.all;
export const seventhAnalysisIsFetching = state => state.seventhAnalyses.loading.seventhAnalysis;